module.exports = __webpack_public_path__ + "assets/img/kv-a0a195c5.png";